export const Footer = () => {
  return (
    <footer className="mt-auto bg-white">
      <hr className="" />
      <div className="text-center py-4 mx-auto">
        <p style={{ margin: 0 }}>
          © {new Date().getFullYear()} cybersecured.social{" "}
        </p>
        <p style={{ margin: 0 }}>
          Powered by <span style={{ color: "#1D8087" }}>cybersecured.team</span>
        </p>
      </div>
    </footer>
  );
};
